export default function validateName(name) {
    return name.replace(/_/g, '').substring(0, 24);
}
